import { render } from "./LoadingChallengePractice.vue?vue&type=template&id=31e2ef30&scoped=true"
import script from "./LoadingChallengePractice.vue?vue&type=script&lang=js"
export * from "./LoadingChallengePractice.vue?vue&type=script&lang=js"

import "@/css/components/loading-challenge-practice.css?vue&type=style&index=0&id=31e2ef30&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31e2ef30"]])

export default __exports__